// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {i_notification} from '../ui/dashboard/utils/notifications';
import {use_rt_data} from './use_rt_data';

interface i_ws_message {
    action: string;
    data?: i_notification;
}
interface i_use_notifications_ws {
    user_id: string;
    on_notification: (notif: i_notification) => void;
}
export const use_notifications_ws = ({
    user_id,
    on_notification,
}: i_use_notifications_ws)=>{
    const ws_url = `wss://${window.location.host}/ws`;
    const {is_connected, messages, send_message} = use_rt_data<i_ws_message>({
        ws_url,
        id: user_id,
        on_message: (msg: i_ws_message)=>{
            if (msg.action === 'get_notification' && msg.data)
                on_notification(msg.data);
        },
    });
    return {
        is_connected,
        messages,
        send_message,
    };
};
